<template>
    <p class="subheadline">Wie sind Sie auf uns Aufmerksam geworden?</p>
    <div class="select">
        <select :value="attentionType" @change="selectAttentionType" required>
            <option disabled value="">Bitte auswählen</option>
            <option v-for="type in allAttentionTypes" :key="type" :value="type">
                {{ getAttentionName(type) }}
            </option>
        </select>
    </div>
    <div v-if="attentionTypeRequiresAdditionalText">
        <label for="attention-additional-text" class="small">Sonstiges</label>
        <textarea id="attention-additional-text" class="textarea"
                  :value="attentionAdditionalText"
                  @input="$emit('update:attentionAdditionalText', $event.target.value)"/>
    </div>
</template>

<script>

import { Attention, getAttentionName } from "@/utils/registration";

export default {
    name: 'RegisterFormPartAttention',
    props: {
        attentionType: String,
        attentionAdditionalText: String,
    },
    computed: {
        allAttentionTypes() {
            return Object.values(Attention);
        },
        attentionTypeRequiresAdditionalText() {
            return this.attentionType === Attention.Other;
        }
    },
    emits: [
        'update:attentionType',
        'update:attentionAdditionalText',
    ],
    methods: {
        getAttentionName(attentionType) {
            return getAttentionName(attentionType)
        },
        selectAttentionType(event) {
            const selectedType = event.target.value;
            this.$emit('update:attentionType', selectedType);
            if (selectedType !== Attention.Other) {
                this.$emit('update:attentionAdditionalText', '');
            }
        }
    }
}
</script>
